import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, userTimezone } from "@/lib/api";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "");
export const gbp = (n) => `£${Number(n).toFixed(2)}`;

export function usePlan() {
  return useQuery({
    queryKey: ["billing"],
    queryFn: () => api.get(`/billing/status?tz=${encodeURIComponent(userTimezone())}`).then((r) => r.data),
    staleTime: 30_000,
  });
}

export function useRefreshPlan() {
  const qc = useQueryClient();
  return () => Promise.all([qc.invalidateQueries({ queryKey: ["billing"] }), qc.invalidateQueries({ queryKey: ["analytics"] }), qc.invalidateQueries({ queryKey: ["quiz-overview"] })]);
}

export const isLimitError = (err) => err?.response?.status === 402;

// Free: AI analyses left this week. Pro: null (unlimited, no counter).
export const aiLeftOf = (plan) => (plan?.plan === "free" ? Math.max(0, plan.usage.ai_logs_limit - plan.usage.ai_logs_used) : null);
